import { useMemo } from 'react';
import { useScrollState } from '@atlassian/jira-software-fast-virtual/src/services/use-scroll-state/index.tsx';
import { useBacklogSelector } from '../../../../state/index.tsx';
import {
	isDragging,
	getIsSubtaskDrag,
	getSourceCardListId,
} from '../../../../state/selectors/drag/index.tsx';

/**
 * When we drag a subtask card and scroll up or down, the backlog crashes because the card group is unmounted.
 * To avoid this, we need to add extra overscan height to the display window so that the card group remains visible.
 */
export const useOverscanHeight = (cardListId: string, defaultOverscanHeight = 0) => {
	const { scrollTop } = useScrollState();
	const isDraggingSubtask = useBacklogSelector(
		(state) => isDragging(state) && getIsSubtaskDrag(state),
	);
	const isDraggingSourceCardlist = useBacklogSelector(
		(state) => getSourceCardListId(state) === cardListId,
	);
	const scrollTopOnDragStart = useMemo(
		() => (isDraggingSubtask && isDraggingSourceCardlist ? scrollTop : undefined),
		// eslint-disable-next-line react-hooks/react-compiler
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[isDraggingSubtask, isDraggingSourceCardlist],
	);

	return (
		defaultOverscanHeight +
		(scrollTopOnDragStart !== undefined ? Math.abs(scrollTop - scrollTopOnDragStart) : 0)
	);
};
